/**
 * Pages that open items at their own sub-paths (a list beside a detail pane, or a Board under a
 * task's pop-up: a project's, or the master board at /board; Chat's sidebar beside its chats, T-54; the
 * Inbox under a task's pop-up, SF-T-236):
 * moving between items keeps the page mounted, so its scroll and state stay put, and the Board isn't
 * fetched again behind a spinner.
 */
const SELF_ROUTED_PAGES = [/^\/p\/[^/]+\/board(?=\/|$)/, /^\/board(?=\/|$)/, /^\/chat(?=\/|$)/, /^\/inbox(?=\/|$)/];

/** The key a page mounts under: a self-routed page keeps one key across its items. */
export function pageKey(pathname: string): string {
  for (const page of SELF_ROUTED_PAGES) {
    const match = page.exec(pathname);
    if (match) return match[0];
  }
  return pathname;
}
